import React, { useState, useEffect } from 'react';

export const BotIcon = ({
    size = 28,
    className = "",
    intervalSeconds = 5,
    strokeWidth = 1,
    fill = false,
    bodyColor = "#efede5ff",
    leavesColor = "#6d9d2aff",
    outlineColor = "#3A4550"
}) => {
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setIsAnimating(true);
        }, intervalSeconds * 1000);

        return () => clearInterval(interval);
    }, [intervalSeconds]);

    useEffect(() => {
        if (isAnimating) {
            const t = setTimeout(() => setIsAnimating(false), 1300);
            return () => clearTimeout(t);
        }
    }, [isAnimating]);

    const eyeStyle = {
        transformOrigin: 'center',
        animation: isAnimating ? 'botEyeMove 1.3s ease-in-out' : 'none',
    };

    return (
        <>
            <style>{`
                @keyframes botEyeMove {
                    0% { transform: translateX(0) translateY(0); }
                    33% { transform: translateX(-1.5px) translateY(1.5px); }
                    66% { transform: translateX(1.5px) translateY(1.5px); }
                    100% { transform: translateX(0) translateY(0); }
                }
            `}</style>

            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={fill ? outlineColor : "white"}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
                className={className}
            >
                <g transform="translate(1, -5) scale(0.9)" fill={fill ? leavesColor : "none"} stroke={fill ? "#456a12ff" : "#outlineColor='#27485C'"}>
                    <path d="M12 9.5v-1.5a2 2 0 0 1 2-2h1a.5.5 0 0 1 .5.5V7a2 2 0 0 1-2 2 2 2 0 0 0-2 2" />
                    <path d="M8 8.5a3 3 0 0 1 4 3 3 3 0 0 1-4-3" />
                </g>

                <path
                    d="M12 7.5C16.1 7.5 18.8 8.6 20.6 10.5C22.4 12.5 23.2 15.3 23.4 18.6C24.5 21.2 23.7 23.9 21.6 26C19.5 28.1 16.1 29.5 12 29.5C7.9 29.5 4.4 28.2 2.2 26.2C0.1 24.2 -0.7 21.5 0.6 18.5C1.4 15.2 2.3 12.5 4.1 10.5C5.9 8.6 8.8 7.5 12 7.5Z"
                    transform="scale(0.7) translate(5, 1)"
                    fill={fill ? bodyColor : "none"}
                />

                <path d="M15 13v2" style={eyeStyle} />
                <path d="M9 13v2" style={eyeStyle} />
            </svg>
        </>
    );
};